import "./SideModal.css";

function SideModal({ open, close, children }) {
  return (
    <>
      <div
        className={`overlay ${open ? "show" : ""}`}
        onClick={close}
      ></div>

      <div className={`sideModal ${open ? "active" : ""}`}>
        <button className="closeBtn" onClick={close}>
          ✕
        </button>

        {children}
      </div>
    </>
  );
}

export default SideModal;